import { render, staticRenderFns } from "./component-upload-image.vue?vue&type=template&id=696fae92&scoped=true&"
import script from "./component-upload-image.vue?vue&type=script&lang=js&"
export * from "./component-upload-image.vue?vue&type=script&lang=js&"
import style0 from "./component-upload-image.vue?vue&type=style&index=0&id=696fae92&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696fae92",
  null
  
)

export default component.exports